import _get from 'lodash/get';
import currencyFormatter from 'currencyformatter.js'; // eslint-disable-line

import moneyUtils from '../utils/money';
import Currency from '../utils/currency';
var getCurrencyCode = moneyUtils.currencyCode;
export var formatCurrencyByLocal = function formatCurrencyByLocal(value, LOCALE) {
  return currencyFormatter.format(value, {
    locale: LOCALE
  });
};
export var formatCurrency = function formatCurrency(value) {
  var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrencyCode();
  var currency = symbol ? symbol.toUpperCase() : '';
  return currencyFormatter.format(value, {
    currency: currency
  });
}; // format currency with symbol without decimal point / integer

export var formatCurrencyWithoutDecimal = function formatCurrencyWithoutDecimal(value) {
  var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrencyCode();
  var currency = symbol ? symbol.toUpperCase() : '';
  var pattern = '!#,##0';
  return currencyFormatter.format(value, {
    currency: currency,
    pattern: pattern
  });
};
export var getCurrencySymbol = function getCurrencySymbol() {
  var currencySymbol = Currency.currencySymbol;
  if (currencySymbol) return currencySymbol;
  var currencyCode = getCurrencyCode() || '';

  var symbol = _get(currencyFormatter, "symbols.".concat(currencyCode.toUpperCase()));

  return symbol;
};
export var getFormattedCostWithCurrency = function getFormattedCostWithCurrency(cost) {
  return formatCurrency(moneyUtils.withPrecision(cost));
};